import { useEffect } from "react";
import "./Servicos.css";
import nsCa from '../../img/ns_ca.png';
import nsLa from '../../img/ns_la.png';
import nsPet from '../../img/ns_pet.png';
import nsTdmr from '../../img/ns_tdmr.png';

function Servicos() {

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("fade-in");
                }
            });
        }, { threshold: 0.1 });

        document.querySelectorAll(".card-servico, .title").forEach((el) => observer.observe(el));

        return () => observer.disconnect();
    }, []);


    return (
        <div className="container-inicial container-servicos" id='servicos'>
            <h1 className="title">Nossos Serviços</h1>

            <div className="cards-servicos">
                <div className="card-servico" id="servico-consultoria">
                    <div className='container-img'>
                        <img src={nsCa} alt="Consultoria Ambiental - diagnóstico e gestão de impactos" loading="lazy" />
                    </div>
                    <div>
                        <h2 className="title-servico">Consultoria Ambiental</h2>
                        <p>Apoiamos negócios na adequação ambiental, garantindo conformidade com normas e eficiência sustentável.</p>
                        <ul>
                            <li>Diagnósticos e estudos técnicos</li>
                            <li>Gestão de impactos ambientais</li>
                            <li>Educação e treinamentos</li>
                        </ul>
                    </div>
                    <div>
                        <a href="https://wa.me/553233210063?text=Ol%C3%A1%2C%20vim%20pelo%20site%20e%20quero%20saber%20mais%20informa%C3%A7%C3%B5es%20sobre%20o%20servi%C3%A7o%20de%20CONSULTORIA%20AMBIENTAL%2C%20prestado%20pela%20Blue%20An%C3%A1lises%20e%20Servi%C3%A7os%20Ambientais." className="button-servico" aria-label="Saiba mais sobre Consultoria Ambiental via WhatsApp">Saiba mais</a>
                    </div>
                </div>

                <div className="card-servico" id="servico-licenciamento">
                    <div className='container-img'>
                        <img src={nsLa} alt="Licenciamento Ambiental - regularização e licenças" loading="lazy" />
                    </div>
                    <div>
                        <h2 className="title-servico">Licenciamento Ambiental</h2>
                        <p>Facilitamos processos de licenciamento, assegurando a regularização ambiental de empreendimentos.</p>
                        <ul>
                            <li>Licenças prévia, de instalação e operação</li>
                            <li>Estudos ambientais e relatórios técnicos</li>
                            <li>Suporte regulatório</li>
                        </ul>
                    </div>
                    <div>
                        <a href="https://wa.me/553233210063?text=Ol%C3%A1%2C%20vim%20pelo%20site%20e%20quero%20saber%20mais%20informa%C3%A7%C3%B5es%20sobre%20o%20servi%C3%A7o%20de%20LICENCIAMENTO%20AMBIENTAL%2C%20prestado%20pela%20Blue%20An%C3%A1lises%20e%20Servi%C3%A7os%20Ambientais." className="button-servico" aria-label="Saiba mais sobre Licenciamento Ambiental via WhatsApp">Saiba mais</a>
                    </div>
                </div>

                <div className="card-servico" id="servico-projetos">
                    <div className='container-img'>
                        <img src={nsPet} alt="Projetos de Estação de Tratamento - soluções para água e efluentes" loading="lazy" />
                    </div>
                    <div>
                        <h2 className="title-servico">Projetos de Estação de Tratamento</h2>
                        <p>Desenvolvemos soluções para tratamento de água e efluentes, garantindo segurança hídrica e respeito ao meio ambiente.</p>
                        <ul>
                            <li>Planejamento e implantação</li>
                            <li>Otimização de processos</li>
                            <li>Adequação às legislações</li>
                        </ul>
                    </div>
                    <div>
                        <a href="https://wa.me/553233210063?text=Ol%C3%A1%2C%20vim%20pelo%20site%20e%20quero%20saber%20mais%20informa%C3%A7%C3%B5es%20sobre%20o%20servi%C3%A7o%20de%20PROJETOS%20DE%20ESTA%C3%87%C3%83O%20DE%20TRATAMENTO%2C%20prestado%20pela%20Blue%20An%C3%A1lises%20e%20Servi%C3%A7os%20Ambientais." className="button-servico" aria-label="Saiba mais sobre Projetos de Estação de Tratamento via WhatsApp">Saiba mais</a>
                    </div>
                </div>

                <div className="card-servico" id="servico-transporte">
                    <div className='container-img'>
                        <img src={nsTdmr} alt="Transporte e Destinação de Resíduos - logística sustentável" loading="lazy" />
                    </div>
                    <div>
                        <h2 className="title-servico">Transporte e Destinação de Resíduos</h2>
                        <p>Contribuímos para a economia circular com a logística e descarte responsável de resíduos CLASSE I, IIA e IIB.</p>
                        <ul>
                            <li>Transporte seguro e eficiente</li>
                            <li>Destinação conforme normas ambientais</li>
                            <li>Estratégias para redução de impactos</li>
                        </ul>
                    </div>
                    <div>
                        <a href="https://wa.me/553233210063?text=Ol%C3%A1%2C%20vim%20pelo%20site%20e%20quero%20saber%20mais%20informa%C3%A7%C3%B5es%20sobre%20o%20servi%C3%A7o%20de%20TRANSPORTE%20E%20DESTINA%C3%87%C3%83O%20DE%20RES%C3%8DDUOS%2C%20prestado%20pela%20Blue%20An%C3%A1lises%20e%20Servi%C3%A7os%20Ambientais." className="button-servico" aria-label="Saiba mais sobre Transporte e Destinação de Resíduos via WhatsApp">Saiba mais</a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Servicos;
